import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import UserRentRow from './UserRentRow';
import FeedbackDialog from '../Feedback/FeedbackDialog';

export class UserRentTable extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      page: 0,
      rowsPerPage: 500,
      open: false,
      modalFeedback: '',
      modalFeedbackOpinion: '',
    };
  }

  handleClose = () => {
    this.setState(
      {
        open: false,
        modalFeedback: '',
        modalFeedbackOpinion: '',
      }
    );
  };

  showFeedback = (message, opinion) => {
    this.setState(
      {
        open: true,
        modalFeedback: message,
        modalFeedbackOpinion: opinion,
      }
    );
  };

  static propTypes = {
    rents: PropTypes.array.isRequired
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const columnData = [
      {
        id: 'start_date', numeric: false, disablePadding: true, label: 'Date de début',
      },
      {
        id: 'end_date', numeric: false, disablePadding: false, label: 'Date de fin',
      },
      {
        id: 'renterName', numeric: false, disablePadding: false, label: 'Loueur',
      },
      {
        id: 'siteName', numeric: false, disablePadding: false, label: 'Site',
      },
      {
        id: 'rent_price', numeric: false, disablePadding: false, label: 'Montant',
      },
      {
        id: 'state', numeric: false, disablePadding: false, label: 'Etat',
      },
      { id: 'user_feedback', label: 'Avis client' },
    ];

    const {
      rowsPerPage, page,
    } = this.state;
    const { rents } = this.props;

    if (rents && rents.length) {
      return (
        <div>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  {columnData.map(column => (
                    <TableCell
                      key={column.id}
                      padding={column.disablePadding ? 'none' : 'normal'}
                    >
                      {column.label}
                    </TableCell>
                  ), this)}
                </TableRow>
              </TableHead>
              <TableBody>
                {rents.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map(rent => (
                  <UserRentRow
                    key={rent.id}
                    rent={rent}
                    showFeedback={this.showFeedback}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
          <KobooTablePagination
            numberOfItems={rents.length}
            rowsPerPage={rowsPerPage}
            label="Locations par page"
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
          <FeedbackDialog
            open={this.state.open}
            handleClose={this.handleClose}
            modalFeedback={this.state.modalFeedback}
            modalFeedbackOpinion={this.state.modalFeedbackOpinion}
          />
        </div>
      );
    }
    return (
      <Typography variant="subtitle1">Aucune Commande</Typography>
    );
  }
}

export default UserRentTable;



// WEBPACK FOOTER //
// ./src/components/Users/UserRentTable.jsx